import AboutPage from './pages/secondary/AboutPage'
import { isValidElement } from 'react'
import ThemeSettingsPage from './pages/secondary/ThemeSettingsPage'
import BlossomPage from './pages/secondary/BlossomPage'
import FavoriteRelaysPage from './pages/secondary/FavoriteRelaysPage'
import FollowingListPage from './pages/secondary/FollowingListPage'
import ForkPage from './pages/secondary/ForkPage'
import GroupedProfilePage from './pages/secondary/GroupedProfilePage'
import InboxPage from './pages/secondary/InboxPage'
import MuteListPage from './pages/secondary/MuteListPage'
import NotePage from './pages/secondary/NotePage'
import OutboxPage from './pages/secondary/OutboxPage'
import BlockedRelaysPage from './pages/secondary/BlockedRelaysPage'
import SearchRelaysPage from './pages/secondary/SearchRelaysPage'
import SimpleGroupsPage from './pages/secondary/SimpleGroupsPage'
import ProfileEditorPage from './pages/secondary/ProfileEditorPage'
import ProfilePage from './pages/secondary/ProfilePage'
import PendingPage from './pages/secondary/PendingPage'
import DangerZonePage from './pages/secondary/DangerZonePage'
import PomegranatePage from './pages/secondary/PomegranatePage'

type MatchResult = false | { params: Record<string, string> }

function exact(expected: string) {
  return (url: string): MatchResult => (url === expected ? { params: {} } : false)
}

function bech32Note() {
  return (url: string): MatchResult => {
    const m = url.match(/^\/((nevent1|naddr1)[a-z0-9]+)$/)
    return m ? { params: { id: m[1] } } : false
  }
}

function bech32Profile() {
  return (url: string): MatchResult => {
    const m = url.match(/^\/((npub1|nprofile1)[a-z0-9]+)$/)
    return m ? { params: { id: m[1] } } : false
  }
}

function bech32ProfileSub(subroute: string) {
  return (url: string): MatchResult => {
    const m = url.match(new RegExp(`^\\/((npub1|nprofile1)[a-z0-9]+)\\/${subroute}$`))
    return m ? { params: { id: m[1] } } : false
  }
}

const ROUTES = [
  { path: '/:bech32', element: <NotePage id="" />, matcher: bech32Note() },
  { path: '/:bech32', element: <ProfilePage id="" />, matcher: bech32Profile() },
  {
    path: '/:bech32/grouped',
    element: <GroupedProfilePage id="" />,
    matcher: bech32ProfileSub('grouped')
  },
  {
    path: '/:bech32/following',
    element: <FollowingListPage id="" />,
    matcher: bech32ProfileSub('following')
  },
  {
    path: '/:bech32/favorite-relays',
    element: <FavoriteRelaysPage id="" />,
    matcher: bech32ProfileSub('favorite-relays')
  },
  { path: '/:bech32/inbox', element: <InboxPage id="" />, matcher: bech32ProfileSub('inbox') },
  { path: '/:bech32/outbox', element: <OutboxPage id="" />, matcher: bech32ProfileSub('outbox') },
  {
    path: '/:bech32/blossom',
    element: <BlossomPage id="" />,
    matcher: bech32ProfileSub('blossom')
  },
  { path: '/:bech32/mutes', element: <MuteListPage id="" />, matcher: bech32ProfileSub('mutes') },
  {
    path: '/:bech32/blocked-relays',
    element: <BlockedRelaysPage id="" />,
    matcher: bech32ProfileSub('blocked-relays')
  },
  {
    path: '/:bech32/search-relays',
    element: <SearchRelaysPage id="" />,
    matcher: bech32ProfileSub('search-relays')
  },
  {
    path: '/:bech32/simple-groups',
    element: <SimpleGroupsPage id="" />,
    matcher: bech32ProfileSub('simple-groups')
  },
  { path: '/theme', element: <ThemeSettingsPage />, matcher: exact('/theme') },
  { path: '/about', element: <AboutPage />, matcher: exact('/about') },
  { path: '/profile-editor', element: <ProfileEditorPage />, matcher: exact('/profile-editor') },
  { path: '/pending', element: <PendingPage />, matcher: exact('/pending') },
  { path: '/danger', element: <DangerZonePage />, matcher: exact('/danger') },
  { path: '/pomegranate', element: <PomegranatePage />, matcher: exact('/pomegranate') },
  { path: '/fork', element: <ForkPage />, matcher: exact('/fork') }
]

export const routes = ROUTES.map(({ path, element, matcher }) => ({
  path,
  element: isValidElement(element) ? element : null,
  matcher
}))
